import { axios } from '@/api/axios.ts';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import type {
  TClientMaintenanceTask,
  TCreateClientMaintenanceTask,
  TUpdateClientMaintenanceTask,
} from './client-maintenance-task.types.ts';

export const clientMaintenanceTaskApi = {
  getClientMaintenanceTasks: async () => {
    const response = await axios.get<TClientMaintenanceTask[]>(`client-maintenance-tasks`);

    return response.data;
  },
  getClientMaintenanceTaskId: async (id: number) => {
    const response = await axios.get<TClientMaintenanceTask>(`client-maintenance-tasks/${id}`);

    return response.data;
  },
  createClientMaintenanceTask: async (clientMaintenanceTask: TCreateClientMaintenanceTask) => {
    const response = await axios.post<TClientMaintenanceTask>(
      `client-maintenance-tasks`,
      clientMaintenanceTask,
    );

    return response.data;
  },
  updateClientMaintenanceTask: async (payload: {
    id: number;
    clientMaintenanceTask: TUpdateClientMaintenanceTask;
  }) => {
    const { id, clientMaintenanceTask } = payload;

    const response = await axios.patch<TClientMaintenanceTask>(
      `client-maintenance-tasks/${id}`,
      clientMaintenanceTask,
    );

    return response.data;
  },
  deleteClientMaintenanceTask: async (id: number) => {
    const response = await axios.delete<TClientMaintenanceTask>(`client-maintenance-tasks/${id}`);

    return response.data;
  },
};

export const clientMaintenanceTaskQueries = createQueryKeys('client-maintenance-task', {
  getClientMaintenanceTasks: () => ({
    queryKey: ['list'],
    queryFn: () => clientMaintenanceTaskApi.getClientMaintenanceTasks(),
  }),
  getClientMaintenanceTaskId: (id: number) => ({
    queryKey: ['maintenance-task', id],
    queryFn: () => clientMaintenanceTaskApi.getClientMaintenanceTaskId(id),
  }),
});
